import { InProductTrialsAppWebComponent } from './component/InProductTrialsAppWebComponent';
import { WEB_COMPONENT_IN_PRODUCT_TRIALS_APP } from '../../../webcomponents.constants';

export { InProductTrialsAppWebComponent };

window.customElements.define(WEB_COMPONENT_IN_PRODUCT_TRIALS_APP, InProductTrialsAppWebComponent);
